var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{staticClass:"md-primary join-event-button",on:{"click":_vm.goToJoinEvent}},[_vm._v(" Login to Enter KAB20 Experience ")])}
var staticRenderFns = []

export { render, staticRenderFns }